import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { transformGiraResponse } from './utils';

const MAX_USERS_DEFAULT = 5;

export const getUsersGiraUrl = (baseUrl: string) => `${baseUrl}/rest/gira/1/`;

export const giraUserQuery = (
	filter: string,
	shouldLimit: boolean,
	MAX_USERS: number = MAX_USERS_DEFAULT,
) => `
    query platformUserPickerFetchByAccountIds {
        users(
            filter: {
                ${filter}
            }
            ${shouldLimit ? `first: ${MAX_USERS}` : ''}
        ) {
            nodes {
                displayName
                key
                accountId
                avatarUrl
            }
        }
    }
`;

type Filter = {
	accountIds?: string[];
	searchString?: string;
};

export const getFilterString = (filter: Filter) => {
	if (filter.accountIds) return `userIds: ["${filter.accountIds.join('","')}"]`;
	if (filter.searchString !== undefined) return `searchString: "${filter.searchString}"`;
	return '';
};

// We only impose a limit to the number of users fetched when we are NOT performing the initial fetch of account IDs
export const getShouldLimit = (filter: Filter) => !(filter && filter.accountIds);

export const fetchGiraUsers = ({
	baseUrl,
	filter = {},
	maxUsers = MAX_USERS_DEFAULT,
}: {
	baseUrl: string;
	filter?: Filter;
	maxUsers?: number;
}) =>
	fetchJson(getUsersGiraUrl(baseUrl), {
		method: 'POST',
		body: JSON.stringify({
			query: giraUserQuery(getFilterString(filter), getShouldLimit(filter), maxUsers),
		}),
	}).then(transformGiraResponse);

export default fetchGiraUsers;
